<template>
  <div class="element-input element-complete">
    <div class="body">
      <div :class="{ on: true }" class="title">알릴의무가 등록되었습니다.</div>
      <div class="label">
        입력해주신 내용을 바탕으로
        보험심사절차가 진행될 예정입니다.
        입력내용에 보충이 필요한 경우
        담당 사원이 전화연락을 드릴 수 있습니다.
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Complete'
}
</script>